import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { DiNetbeans } from "react-icons/di";
import { FaTasks } from "react-icons/fa";
import { IoBookOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import theiaLogo from "../../assets/theia..png";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import toast from "react-hot-toast";
import apiClient from "../../service/Axios";

const ProjectTable = ({ projectData, loading }) => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [toggleCleared, setToggleCleared] = React.useState(false);

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);





  const navigate = useNavigate();

  const handleTheiaLogoClick = (project_title) => {
    apiClient.get(`${process.env.REACT_APP_AUTHENTICATION_API}/user/system-check`)
      .then(response => {
        if (!response.data.permission) {
          window.open(`/guide-line`, '_blank');
        }
        else{
          window.open(`/theia-login/${project_title}`, '_blank');
        }
      })
      .catch(error => {
        console.error("Error fetching permission:", error);
      });
  };
  






  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Status",
      cell: (row) => (
        <div className="flex justify-center items-center gap-4">
          <button
            className={` ${
              row.status === "Started"
                ? "bg-blue-100 text-blue-600"
                : row.status === "Not Started"
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-500"
            }  px-3 py-1 rounded-md`}>
            {row.status}
          </button>
        </div>
      ),
    },

    {
      name: "Timeline",
      selector: (row) => {
        return (
          <div>
            <p>Start: {row?.startdate}</p>
            <p>End: {row?.enddate}</p>
          </div>
        );
      },
    },
    {
      name: "Quick Action",
      cell: (row) => (
        <div className="flex justify-center items-center gap-4">
          <div className="group tooltip tooltip-right" data-tip="Documentation">
            <div
              className="bg-gray-200 hover:bg-blue-500 text-blue-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center"
              // onClick={(e) => handleButtonClick(e, row.id)}
            >
              <IoBookOutline className="text-[19px] p-[2px]" />
            </div>
          </div>

          <div className="group tooltip tooltip-right" data-tip="Studio">
            <div className="bg-gray-200 hover:bg-blue-500 text-blue-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center">
              <DiNetbeans className="text-[22px] p-[2px]" />
            </div>
          </div>

          <div className="group tooltip tooltip-right" data-tip="Tasks">
            <div className="bg-gray-200 hover:bg-blue-500 text-blue-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center">
              <FaTasks className="text-[17px] p-[2px]" />
            </div>
          </div>
          {/* <Link to="/theia-login">
            <div className="group">
              <div className="bg-gray-200 hover:bg-red-500 text-red-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center">
                <BsDatabase className="text-[17px] p-[2px]" />
              </div>
            </div>
          </Link> */}
          
          
          
          
          {/* <Link
            to={`/theia-login/${encodeURIComponent(
              row.title.replace(/\s+/g, "")
            )}`}
            target="_blank">
            <div className="group tooltip tooltip-right" data-tip="IDE">
              <div className="bg-gray-200 hover:bg-blue-500 text-blue-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center">
                <img src={theiaLogo} alt="" />
              </div>
            </div>
          </Link> */}

    

          <div className="group tooltip tooltip-right" data-tip="IDE">
            <div className="bg-gray-200 hover:bg-blue-500 text-blue-500 group-hover:text-white h-7 w-7 rounded-full flex justify-center items-center">
              <img onClick={() => handleTheiaLogoClick(`${encodeURIComponent(row.title.replace(/\s+/g, ""))}`)} src={theiaLogo} alt="" />
            </div>
          </div>
    










        </div>
      ),
    },
  ];

  const contextActions = React.useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.title
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        // setData(differenceBy(data, selectedRows, 'title'));
      }
    };

    return (
      <button
        key="delete"
        onClick={handleDelete}
        style={{ backgroundColor: "red" }}
        icon>
        Delete
      </button>
    );
  }, [projectData, selectedRows, toggleCleared]);

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center mt-20">
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration=".5s"
          />
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={projectData}
          selectableRows
          contextActions={contextActions}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          pagination
        />
      )}
    </>
  );
};

export default ProjectTable;
